/* eslint-disable react/prop-types,no-shadow */
import React from 'react';
import { connect } from 'react-redux';
import { notification } from 'antd';
import { injectIntl } from 'react-intl';
import {
  setEditFolderViewVisible,
  setEditFolderData,
  setDeletedFolderData,
  uploadFolders,
  sortValues,
  setUserFolderData,
} from '../../flow/action';
import { EditFolder } from '../component';
import { getTeamUsers } from '../../flow/reselect';

const errorMsg = text =>
  notification.error({
    duration: 3,
    message: text,
  });

class EmailTemplateEditFolder extends React.Component {
  componentDidMount() {
    const { setEditFolderData, userFolders } = this.props;
    setEditFolderData(userFolders);
  }

  // Swap algorithm
  // According to how the drag function is worked (in other words, when moveCard is being called), we only swap with one adjacent card every time,
  swapCards = (cards, start, newStart) => {
    const { sortValues } = this.props;
    const cardsCopy = _.cloneDeep(cards);
    const dragCards = cardsCopy.splice(start, 1);
    // Insert dragged card into new positions
    cardsCopy.splice(newStart, 0, dragCards[0]);

    sortValues(cardsCopy);
    return cardsCopy;
  };

  moveCard = (dragIndex, hoverIndex) => {
    const { sortValues, editFolders } = this.props;

    const newCards = this.swapCards(editFolders, dragIndex, hoverIndex);
    sortValues(newCards);
  };

  validateBeforeSave = () => {
    const { editFolders, intl } = this.props;
    const { formatMessage } = intl;

    if (_.uniqBy(editFolders, 'name').length !== editFolders.length) {
      errorMsg(
        formatMessage({ id: 'page.emailTemplates.duplicatedFolderName' }),
      );
      return false;
    }
    const folderNameEmpty = editFolders.some(folder => _.isEmpty(folder.name));
    if (folderNameEmpty) {
      errorMsg(formatMessage({ id: 'page.emailTemplates.emptyFolderName' }));
      return false;
    }
    return true;
  };

  saveEditFolder = (editFolders, deletedFolders) => {
    const { setEditFolderViewVisible, uploadFolders } = this.props;
    const validateData = this.validateBeforeSave();
    if (validateData) {
      setEditFolderData(editFolders);
      setDeletedFolderData(deletedFolders);
      uploadFolders(
        () => setEditFolderViewVisible(false),
        editFolders,
        deletedFolders,
      );
    }
  };

  render() {
    const {
      editFolders,
      deletedFolders,
      setEditFolderViewVisible,
    } = this.props;
    return (
      <EditFolder
        editFolders={editFolders}
        deletedFolders={deletedFolders}
        setEditFolderViewVisible={setEditFolderViewVisible}
        saveEditFolder={this.saveEditFolder}
        moveCard={this.moveCard}
      />
    );
  }
}

const mapStateToProps = ({ global, setup }) => {
  const { emailTemplates } = setup;
  return {
    lang: global.language,
    teamUsers: getTeamUsers({ emailTemplates }),
    isEditFolderViewVisible: emailTemplates.ui.isEditFolderViewVisible,
    editFolders: emailTemplates.editFolders,
    deletedFolders: emailTemplates.deletedFolders,
    userFolders: emailTemplates.userFolders,
  };
};

const mapDispatchToProps = {
  setEditFolderViewVisible,
  setEditFolderData,
  setDeletedFolderData,
  uploadFolders,
  sortValues,
  setUserFolderData,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(EmailTemplateEditFolder));



// WEBPACK FOOTER //
// ./src/views/email/emailTemplates/container/emailEditFolder.js